import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-circular-progress',
  templateUrl: './circular-progress.component.html',
  styleUrls: ['./circular-progress.component.css']
})
export class CircularProgressComponent implements OnInit {
  @Input() currentValue: any
  @Input() outerColor: any
  @Input() title: any
  @Input() subTitle: any
  @Input() subTitleSize: any
  @Input() titleFontSize: any
  @Input() titleFontWeight: any
  @Input() titleColor: any
  constructor() { }

   ngOnInit(): void {
      

  }

}
